const POSTCODE_REGEX = new RegExp(TYROOLA.globals.postcodeValidation);

/**
 * Simple Postcode validator
 * @constructor
 */
class PostcodeValidator {
    /**
     * @param {String}postcode
     * @returns {Boolean}
     */
    isValid(postcode) {
        return PostcodeValidator.validate(postcode);
    }
    
    static validate(postcode) {
        return POSTCODE_REGEX.test(postcode);
    }
}

export { PostcodeValidator };
export default PostcodeValidator;
